// ======================================================================
// File Name       : TranslateConfirmContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Col, Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import * as modalActions from '../../actions/ModalAction';
import * as MultiLanguageAction from '../../actions/MultiLanguageAction';
import * as ModalIds from '../../constants/ModalIds';
import { hideLoading, showLoading } from '../../utils/PageUtils';
import ModalWrapper from '../modal/ModalWrapper';
import TranslateConfirm from './TranslateConfirm';

class TranslateConfirmContainer extends React.Component {
  constructor(props) {
    super(props);
    this.getModalOptions = this.getModalOptions.bind(this);
    this.handleStartTranslate = this.handleStartTranslate.bind(this);
  }

  getModalOptions() {
    return {
      title: '翻訳を開始してよろしいですか？',
      footerBtns: [
        { name: 'キャンセル', onClick: this.props.hideModal, variant: 'default' },
        { name: '翻訳開始', onClick: this.handleStartTranslate, variant: 'primary' },
      ],
    };
  }

  handleStartTranslate() {
    const { dispatch, multiLanguageEditForm } = this.props;
    const { contentSecernId, languageCode } = multiLanguageEditForm.values;
    if (contentSecernId && languageCode) {
      dispatch(showLoading());
      dispatch(MultiLanguageAction.translate(contentSecernId, languageCode)).then((error) => {
        dispatch(hideLoading());
        if (!error) {
          this.props.hideModal();
          dispatch(modalActions.openModal(ModalIds.TRANSLATE_COMPLETE));
        }
      });
    }
  }

  render() {
    return (
      <ModalWrapper
        {...this.getModalOptions()}
        hideModal={this.props.hideModal}
      >
        <div>
          <Col sm={12} className="text-left margin-bottom-10">
            <p>翻訳済みのドキュメントについては、上書きが実施されます。</p>
            <p>翻訳後のページ数に応じて課金が発生します。</p>
          </Col>
          <Form className="col-sm-12 margin-top-20">
            <TranslateConfirm
              formValues={this.props.multiLanguageEditForm.values}
            />
          </Form>
        </div>
      </ModalWrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { authority, authed } = state;
  const { multiLanguageEditForm } = state.form;
  const { authedUser } = authed;
  const { userInfo } = authedUser;
  return {
    ...{ multiLanguageEditForm },
    authority: authority.authorityInfo,
    userInfo,
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'translateConfirmForm',
    touchOnChange: true,
  })(TranslateConfirmContainer),
);
